import { Directive, HostListener, Input } from '@angular/core';
import { AlertService, ResourceService } from 'sce-core';

@Directive({
  selector: '[sanitizePaste]'
})
export class SanitizePasteDirective {
  /**
   * Controls whether paste sanitization is enabled.
   * Set to false to allow pasting of non-ASCII (e.g., Unicode) characters, such as emojis or foreign scripts.
   * Disable sanitization when input fields require full Unicode support or when sanitization is not desired.
   */
  @Input() isSanitizeEnable: boolean = true;
  constructor(private readonly alertService:AlertService,public resourceService:ResourceService) {}
  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    if (!this.isSanitizeEnable) {
      return;
    }
    const clipboardData = event.clipboardData || window['clipboardData'];
    let pastedText = clipboardData.getData('text');
    const regex = /[^\x00-\x7F]/g; // Regex to match non-UTF-8-compatible characters (non-ASCII range)
    if (regex.test(pastedText)) {
      this.alertService.warn(this.resourceService.get('sanitize_paster_warn'));
    }
    // Regex to remove non-UTF-8-compatible characters (non-ASCII range)
    pastedText = pastedText.replace(/[^\x00-\x7F]/g, '');

    // Insert the sanitized text
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const start = target.selectionStart || 0;
    const end = target.selectionEnd || 0;

    const newText = target.value.slice(0, start) + pastedText + target.value.slice(end);
    target.value = newText;
    // Manually trigger input event if needed
    target.dispatchEvent(new Event('input'));
    target.dispatchEvent(new Event('change', { bubbles: true }));
    // Prevent default paste
    event.preventDefault();
  } 
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/directives/sanitize-paste.directive.ts